export default __webpack_public_path__ + "static/media/fridge1-after1-1440w.ced2c322.webp";